var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.campaign)?_c('router-view',{attrs:{"campaign":_vm.campaign}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }